module.exports = __webpack_public_path__ + "b55fd97542c2bd711343958a89449cd9.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-overpass-mono/files/overpass-mono-latin-700.woff
// module id = 173
// module chunks = 1